import alertsSlice from "./alertsSlice";
import localStorageSlice from "./localStorageSlice";

const InternalSdkReducers = {
    alertsSlice,
    localStorageSlice
};

export * from "./alertsSlice";
export * from "./localStorageSlice";
export { InternalSdkReducers };
